import { SecondaryTileLabeledInputContext } from './secondary-tile.context.js';
import { deprecatedComponent } from '../core/deprecated-component.js';
import { createComponent } from '../core/create-component.js';
import { useNonNullishContext } from '../../hooks/use-non-nullish-context.js';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
/**
 * @subcomponent SecondaryTile
 * @deprecated Use Standard Tile instead, which provides a better user experience.
 */ const SecondaryTileLabeledInputButton = deprecatedComponent({
    displayName: 'SecondaryTileLabeledInputButton',
    description: 'SecondaryTileLabeledInputButton is deprecated; use Standard Tile instead, which provides a better user experience.',
    root: createComponent({
        displayName: 'SecondaryTileLabeledInputButton',
        root: 'button',
        propConfig: {
            classNames: [
                'swan-button',
                'swan-button-full-width',
                'swan-button-mini'
            ],
            derivedProps () {
                return useNonNullishContext(SecondaryTileLabeledInputContext);
            },
            processProps (props, derivedProps) {
                const { labelId } = derivedProps;
                return _object_spread_props(_object_spread({}, props), {
                    'aria-labelledby': labelId || undefined
                });
            }
        }
    })
});

export { SecondaryTileLabeledInputButton };
